export const generalKey = 'product_bk620';
export const whiteLocaleList = ['eu', 'uk', 'de', 'fr', 'it', 'es']; //白名单
export const whiteLocaleList1 = ['us']; //us白名单
export const productPageUrl = 'stream-balcony-solar-system';
export const tabsValues = ['Product', 'Bundles'];
export const productPageTheme = 'white'; //主题色
